document.addEventListener("DOMContentLoaded", () => {
    if (!customElements.get('card-swiper')) {
        class CardSwiper extends HTMLElement {
            cardSwiperEvent;
            constructor() {
                super();
                this.benefitsslides = this.querySelector('.benefits-container');
                this.blocks_size = parseInt(this.benefitsslides.attributes['data-blocks'].value.trim());
            }
            connectedCallback() {

                this.cardSwiperEvent = new Swiper(this.benefitsslides, {
                    slidesPerView: 3,
                    loop: true,
                    breakpoints: {
                        769: {
                            slidesPerView: 3,
                            allowTouchMove: this.blocks_size < 4 ? false : true,
                        },
                        501: {
                            slidesPerView: 2,

                        },
                        300: {
                            slidesPerView: 1.3,
                        },
                    }
                });

                this.initEvent(this.cardSwiperEvent);
            }

            /**
             * 轮播图切换事件
             */
            handleSlideChange(swiper) {

            }

            initEvent(swiper) {

            }

        }
        customElements.define('card-swiper', CardSwiper);
    }
});